import React, { useState, useEffect } from 'react'
import axios from 'axios'

import { swalChoose, swalNotify } from '../../common/components/Swaler'
import { groupBy } from '../../common/utils'

const ApproveAccess = () => {
  const [requests, setRequests] = useState(null)

  const submitAccess = (lockId, customer, data) => {
    swalChoose('Säker?', `Vill du verkligen ${data.isApproved ? 'tillåta' : 'neka'} åtkomst för ${customer.name} ${customer.surname || ''}?`, ['Ja', 'Avbryt']).then((r) => {
      if (r.dismiss) return

      axios.put(`${window.MYQLOCX_API}/subject/admin/locks/${lockId}/accessrequests`, data).then(() => {
        swalNotify('Sparat!')
        setRequests(requests.filter((req) => req.lockId !== lockId))
      })
    })
  }

  useEffect(() => {
    if (!requests) axios.get(`${window.MYQLOCX_API}/subject/admin/locks/accessrequests`).then((r) => setRequests(r.data))
  }, [requests])

  if (!requests) return null

  const groupedRequests = groupBy(requests, (r) => r.lockName)

  return (
    <div>
      <h1>Förfrågningar</h1>
      {[...groupedRequests.keys()].map((key) => (
        <div key={key}>
          <h4>{key}</h4>
          {groupedRequests.get(key).map((r) => (
            <div className="flex" key={r.userId}>
              <div>{`${r.customer.name} ${r.customer.surname || ''}, ${r.customer.phone || ''}`}</div>
              <div>
                <button onClick={() => submitAccess(r.lockId, r.customer, { userId: r.userId, isApproved: true })}>Tillåt</button>
                <button onClick={() => submitAccess(r.lockId, r.customer, { userId: r.userId, isApproved: false })}>Neka</button>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default ApproveAccess
